function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 6.25863C14.5 6.25863 15.5 6.5 16 7C16 6.5 17 5.5 18 5.5C19 5.5 23 10 23 13.5C23 13.5 23 17.5 21.5 17.5C20.5 17.5 20.5 17.5 20.5 16.5C20.5 18.5 19.5 22.5 13.5 22.5C7.5 22.5 6.5 18 6.5 16.5C6.5 17.5 6.5 17.5 5.5 17.5C4 17.5 4 13.5 4 13.5C4 10 7.5 5.5 9 5.5C10 5.5 11 6.5 11 7C11.5 6.5 12.5 6.25863 13.5 6.25863Z",
  fill: "#FFAF00",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.00001 9.5C7.00001 9.5 5.00001 13 5.00001 14C5.00001 14.5351 4.91853 14.5348 5 15M17 9.5C17 9.5 19 13 19 14C19 18.5 16 20.5 12 20.5C10 20.5 8.25001 20 7.00001 18.9375",
  stroke: "#FFAF00",
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 14.5C19 15.5 19 15.5 20 15.5C20.75 15.5 21.125 14.5 21.3125 13.5M5 14.5C5 15.5 5 15.5 4 15.5C2.5 15.5 2.5 11.5 2.5 11.5C2.5 8 6 3.5 7.5 3.5C8.5 3.5 9.5 4.5 9.5 5C10 4.5 11 4.25863 12 4.25863C13 4.25863 14 4.5 14.5 5C14.5 4.5 15.5 3.5 16.5 3.5C17.3159 3.5 20.1291 6.49588 21.1371 9.5",
  stroke: "#FFAF00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 11.5,
  r: 1,
  fill: "#FFAF00"
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 11.5,
  r: 1,
  fill: "#FFAF00"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12 20.5V18.5",
  stroke: "#FFAF00",
  strokeLinecap: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7324 16C13.9026 15.8529 14 15.6821 14 15.5C14 14.9477 13.1046 14.5 12 14.5C10.8954 14.5 10 14.9477 10 15.5C10 16.0523 10.8954 16.5 12 16.5C12.3643 16.5 12.7058 16.4513 13 16.3662M13.7324 16C13.5568 16.1518 13.3036 16.2784 13 16.3662M13.7324 16L13 16.3662",
  stroke: "#FFAF00",
  strokeLinecap: "round"
});
const SvgAnimals = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnimals, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/animals.d7055ae8.svg";
export { ForwardRef as ReactComponent };